import {context} from 'vue3-starter/src/typescript/app-context/AppContext';
import {HttpServiceResponse} from 'vue3-starter/src/typescript/http/http';
import {urlService} from 'vue3-starter/src/typescript/http/UrlService';
import BriefResource from '@/brief-hub/brief/BriefResource';
import {briefResourceBuilder} from '@/brief-hub/brief/BriefResourceBuilder';
import * as RawModel from '@/common/api/api-raw-types';
import {briefCurrencyResourceBuilder} from '@/brief-hub/brief/BriefCurrencyResourceBuilder';
import BriefCurrencyResource from './BriefCurrencyResource';

export class BriefService {
    async retrieveBrief(briefId: string): Promise<HttpServiceResponse<BriefResource>> {
        const [data, error] = await context.httpService.get<RawModel.BriefResource>(urlService.buildUrl(context.registry.entries.brief(), briefId));
        if (error || !data) {
            return [null, error];
        }
        return [briefResourceBuilder.build(data), error];
    }

    async createBrief(payload: RawModel.FreelancerBriefRequest): Promise<HttpServiceResponse<BriefResource>> {
        const [data, error] = await context.httpService.post<RawModel.BriefResource>(context.registry.entries.freelancerProfile(), payload);
        if (error || !data) {
            return [null, error];
        }
        return [briefResourceBuilder.build(data), error];
    }

    async getByRef(briefRef: string): Promise<HttpServiceResponse<BriefResource>> {
        const [data, error] = await context.httpService.get<RawModel.BriefResource>(briefRef);
        if (error || !data) {
            return [null, error];
        }
        return [briefResourceBuilder.build(data), error];
    }

    async getBriefCurrency(): Promise<HttpServiceResponse<BriefCurrencyResource>> {
        const [data, error] = await context.httpService.get<RawModel.BriefCurrencyResource>(context.registry.entries.strategyBriefCurrency());
        if (error || !data) {
            return [null, error];
        }
        return [briefCurrencyResourceBuilder.build(data), error];
    }
}

const briefService = new BriefService();

export default briefService;
